
import { Alert, Button, Dialog, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { AppState, InvitationAttrs, apiPost, brandNewInvitation, hasErrors, invitationSlice, lang, userEmailSelector, userSelector } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { appStore } from '../../store';

const newInvitation: InvitationAttrs = { ...brandNewInvitation };

export const InviteUser = (props: { userId: ModelId, onClose: () => void; }) => {
    const user = useSelector((state: AppState) => userSelector.selectById(state, props.userId));
    const userEmail = useSelector((state: AppState) => user?.emailId ? userEmailSelector.selectById(state, user.emailId) : undefined);
    const [error, setError] = React.useState('');
    const [userInvitation, setUserInvitation] = React.useState<InvitationAttrs>({ ...newInvitation });

    React.useEffect(() => {
        if (user) {
            update({ userId: user.id });
            if (userEmail) {
                update({ userCode: userEmail.email.split('@')[0] });
            }
        }
    }, [user]);


    const update = (p: Partial<InvitationAttrs>) => {
        setUserInvitation(q => { return { ...q, ...p }; });
    };

    if (!user) return <></>;

    const send = async () => {
        const result = await apiPost('userInvite', userInvitation);
        if (typeof result == 'string') {
            setError(result);
        } else {
            setError(result.__err ?? '');
            setUserInvitation(result);
            if (!hasErrors(result)) {
                appStore.dispatch(invitationSlice.actions.addOne(result));
                props.onClose();
            }
        }

    };
    return <Dialog
        open={true}
        onClose={props.onClose}
    >

        <DialogContent>
            <DialogTitle>Inviter {user.name}</DialogTitle>
            <Grid container sx={{ p: 2 }} spacing={2}>
                <Grid item xs={12}>
                    <Typography fontSize={12}>Veuillez choisir le code utilisateur que cette personne devra utiliser pour se connecter à la plateforme. Une invitation sera transmise par courriel à l'adresse <strong>{userEmail?.email}</strong>.</Typography>
                </Grid>
                {error !== '' && <Grid item xs={12}><Alert color='error'>{error}</Alert></Grid>}
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        error={!!userInvitation.__errors?.userCode}
                        helperText={userInvitation.__errors?.userCode ?? lang('usercodeHelperText')}
                        label='Code utilisateur'
                        value={userInvitation.userCode}
                        onChange={(event) => {
                            update({ userCode: event.target.value });
                        }} />
                </Grid>
                <Grid item xs={12}>
                    <Button variant='outlined' onClick={send}>Envoyer</Button>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>;
};
